import React from 'react'
import { DepositList } from './list/page'

export const DepositPage = (): JSX.Element => {
  return <DepositList></DepositList>
}
